const state = {
  xbToken: '',
  xbUserInfo: {},
  xbLoginStatus: false,
  dbToken: '',
  dbUserInfo: {},
  dbLoginStatus: false
}
export default state
